module.exports = __webpack_public_path__ + "img/ic_gear.62131f54.svg";